import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const FormFooterStyled = styled('div')(() => ({
  zIndex: 1,
  height: 81,

  '.formFooter-content': {
    position: 'fixed',
    bottom: 0,
    borderTop: `1px solid ${Colors.gray200}`,
    backgroundColor: Colors.white,
    width: '100%',
    margin: '0 -32px',
    padding: '0 32px',
    height: 81,
    marginTop: 8,
  } as CSSObject,
}));

export const EmptyStateStyled = styled('div')(() => ({
  height: 32,
}));
